import { render } from "./DefaultDataDesc.vue?vue&type=template&id=0ccdd4ce"
import script from "./DefaultDataDesc.vue?vue&type=script&lang=js"
export * from "./DefaultDataDesc.vue?vue&type=script&lang=js"

import "./DefaultDataDesc.vue?vue&type=style&index=0&id=0ccdd4ce&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__